import React, { Component } from 'react';
import { get, getLeaderName, getRoomName, formatDate, getMinistryName, getEventForWeekly } from '../util/Utility.js';
import { Modal, Glyphicon } from 'react-bootstrap';
import moment from 'moment';
import BigCalendar from 'react-big-calendar';

BigCalendar.setLocalizer(
  BigCalendar.momentLocalizer(moment)
);

export default class EventsWeekView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      events: [],
      event: null
    }

    get("events", this, {
      orderByChild: 'date',
      startAt: moment().startOf('day').unix()
    }, e => !e.canceled).then(objects => {
      objects.forEach(object => {
        object.start = moment.unix(object.date).toDate();
        object.end = moment.unix(object.endDate).toDate();
      });
      this.setState({events: objects}, () => {
        get("weekly", this, null, e => !e.archived, false).then(objects => {
          let events = [];
          Object.keys(objects).forEach(key => {
            let object = objects[key];
            getEventForWeekly({...object, key}, true).forEach(event => {
              console.warn(event);
              event.start = moment.unix(event.date).toDate();
              event.end = moment.unix(event.endDate).toDate();
              events.push(event);
            })
          });
          this.setState({events: this.state.events.concat(events)});
        });
      });
    });
  }


  render() {

    let event = this.state.event;
    let isWeekly = event !== null ? event.interval !== undefined : false;

    return ( <center>
      <div style={{maxWidth: 1000, height: 800, margin: 40}}>
        <p style={{marginBottom: 25, fontSize: 15}}>Important Note: Only future events are shown, and repeating events are only shown up to 4 weeks in advance.</p>
        <BigCalendar
          popup
          selectable
          onSelectEvent={event => getMinistryName(event.ministryID, this).then(name => this.setState({event: {...event, ministryName: name}}))}
          events={this.state.events}
          defaultDate={new Date()}
          views={['month', 'week']}
          timeslots={2}
        />
      </div>
      <Modal show={event !== null} onHide={() => this.setState({event: null})}>
        <Modal.Header closeButton>
          {event !== null && <Modal.Title>{event.title}</Modal.Title>}
        </Modal.Header>
        {event !== null && <Modal.Body>
          <div style={{height: 7}} />
          <p><Glyphicon glyph="time" /> {formatDate(event.date, event.endDate)}</p>
          <p><Glyphicon glyph="map-marker" /> Located at {event.atCCO ? "CCO in the " + getRoomName(event) : event.location}</p>
          <p style={{fontWeight: 'bold', marginBottom: 0}}>Event Description</p>
          <p>{event.description}</p>
          <p style={{marginTop: 10, color: 'gray'}}><Glyphicon glyph="heart" /> Hosted by {event.ministryName}</p>
          {!isWeekly && <p style={{marginTop: 10, color: 'gray'}}><Glyphicon glyph="user" /> Created By {getLeaderName(event.originator)}</p>}
        </Modal.Body>}
      </Modal>
    </center> );
  }
}



/** WEBPACK FOOTER **
 ** ./src/overview/CalendarView.js
 **/